module.exports = __webpack_public_path__ + "img/tarj2-4.a08058e8.png";